import {
	OrderItemProduct,
	OrderItems,
	OrderSummary,
} from 'integration/generated/custom/data-contracts';
import {
	WishlistWishlistItem,
	WishlistWishlistItemItem,
} from 'integration/generated/transactions/data-contracts';

export const getLatestChanges = (lists: WishlistWishlistItem[]) => {
	const threeMonthsAgo = new Date();
	threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);

	return lists
		.flatMap((list) =>
			(list.item || []).map((item: WishlistWishlistItemItem) => ({
				partNumber: item.partNumber,
				description: list.description ?? '',
				listId: list.uniqueID ?? '',
				_date: item?.itemCreatedTime ? new Date(item.itemCreatedTime) : null,
			}))
		)
		.filter(
			(item): item is typeof item & { _date: Date } =>
				item._date !== null && !isNaN(item._date.getTime())
		)
		.filter((item) => item._date.getTime() >= threeMonthsAgo.getTime())
		.sort((a, b) => b._date.getTime() - a._date.getTime())
		.slice(0, 5)
		.map(({ _date, ...rest }) => rest);
};

export const getPurchasedProducts = (
	Order?: OrderSummary[],
	OrderItems?: OrderItems[],
	targetPartNumbers?: string[]
): string[] => [
	...new Set(
		Order?.flatMap((order) => {
			const items = OrderItems?.find((oi) => oi.orderId === order.orderId)?.items || [];

			return items
				.filter((item: OrderItemProduct) => targetPartNumbers?.includes(item.partNumber))
				.map((item: OrderItemProduct) => item.partNumber);
		}) || []
	),
];
